module.exports = __webpack_public_path__ + "img/auto-email_.9a3e89d4.png";